import { Button } from "@atoms"
import ErrorLayout from "modules/layout/error"
import { ReactComponent as RefreshIcon } from "assets/icons/refresh.svg"
import { useTranslation } from "react-i18next"

interface Props {
  reset(): void
}

const UnexpectedError: React.FC<Props> = ({ reset }) => {
  const { t } = useTranslation("translation")
  return (
    <ErrorLayout>
      <ErrorLayout.Icon />
      <ErrorLayout.Error>{t("unexpected_error.title")}</ErrorLayout.Error>
      <ErrorLayout.Title>{t("unexpected_error.sub_title")}</ErrorLayout.Title>
      <ErrorLayout.Subtitle>
        {t("unexpected_error.message")}{" "}
        <a target="_blank" href="mailto:support@amalyet.com" rel="noreferrer">
          support@amalyet.com
        </a>
        .
      </ErrorLayout.Subtitle>
      <ErrorLayout.Actions>
        <Button color="primary" onClick={reset}>
          <RefreshIcon />
          <span>{t("unexpected_error.try_again")}</span>
        </Button>
      </ErrorLayout.Actions>
    </ErrorLayout>
  )
}

export default UnexpectedError
